// extracted by mini-css-extract-plugin
module.exports = {"container":"_2xkaX9tUCOVfz7mgQaOXlK","groupsList":"_2YkzLaM5wOBD8HqmNEYSQI"};